import { templateThemeTokens } from './templateThemeTokens.js';
import { fontStacks } from '@/stitches/fonts.js';
import { createTheme } from '@/stitches/index.js';
import { merge } from 'lodash-es';

const mergedTokens = merge(templateThemeTokens, {
  colors: {
    defaultFont: '#FCE9E9',
    pageBackground: '#CD74DD',
  },
  fonts: {
    body: fontStacks.generalSans.value,
    heading: fontStacks.generalSans.value,
  },
});

export const dusk = createTheme({ ...mergedTokens });
